export default __webpack_public_path__ + "static/media/ollama-logo.e174bef7.png";